import Desktop from ".";
import { applyClickUndo, isDev } from "@/modules/commonMobile";
import { clearModals, setWinModal } from "@/modules/modals";
import { defaultBaccaratResult, defaultDragonTigerResult, defaultShioFightResult } from "@/modules/virtualCards";

// Only for Lobby
export default function LobbyKeyDownHandler(this: Desktop, event: KeyboardEvent) {
	const {
		games,
		timers,
		maximisedGamePcode: pcode
	} = this.state;

	if (!games ||
		!timers ||
		!pcode ||
		!isDev()) return;

	const game = games[pcode];
	const timer = timers[pcode];

	if (event.which === 27) {
		//Closes all popups
		this.setState({
			showTransactionHistoryPopup: false,
			showResultHistory: false,
			showInfoNews: false,
			showHowToPlay: false,
			showSettingsPopup: false,
		});
	}

	if (pcode === "m26" ||
		pcode === "m30") {

		switch (event.key) {
			// Keys 1-0 adds a number
			case "1":
			case "2":
			case "3":
			case "4":
			case "5":
			case "6":
			case "7":
			case "8":
			case "9":
				if (pcode === "m26")
					this.addNumberM26NotDom(game, +event.key);
				if (pcode === "m30")
					this.addNumberM30NotDom(game, +event.key);

				this.checkController(game); // keydown Backspace
				this.setState({ games: games }); // keydown Backspace
				break;
			case "0":
				if (pcode === "m26")
					this.addNumberM26NotDom(game, 10);
				if (pcode === "m30")
					this.addNumberM30NotDom(game, 0);

				this.checkController(game); // keydown Backspace
				this.setState({ games: games }); // keydown Backspace
				break;

			// Backspace commits undo
			case "Backspace":
				// Copied from clickUndo
				applyClickUndo(game); // keydown Backspace
				this.checkController(game); // keydown Backspace
				this.setState({ games: games }); // keydown Backspace
				break;

			default: break;
		}
	}

	switch (event.key) {
		case "e":
			// Removes all win animations
			this.removeWins();
			break;

		case "l":
			//Dummy loadNewValue
			let loadNewValueData = null;

			switch (pcode) {
				case "p9":
					loadNewValueData = { "game": "12d", "win": "20", "timer": "60", "periode": 1022932 };
					break;

				case "m13":
					loadNewValueData = { "game": "billiards", "pcode": "m13", "win": "10", "type": "Even", "timer": "60", "periode": 471450 };
					break;

				case "m16":
					// loadNewValueData = {
					// 	"game": "gong_ball",
					// 	"alias": "GB",
					// 	"win": {
					// 		"angka": "5,5,4",
					// 		"angka1": "5,3,1",
					// 		"angka2": "5,5,4",
					// 		"result": "Player"},
					// 	"pcode": "m16", "timer": "30", "periode": 503629};
					loadNewValueData = {
						"game": "gong_ball", "alias": "GB",
						"win":
						{
							// "angka": "K,9,3", 
							"angka1": "7,9,J",
							"angka2": "K,9,3",
							"result": "Banker"
						},
						"pcode": "m16", "timer": "30", "periode": 503715
					};
					break;

				case "m33":
					//Todo: test this loadNewValue
					loadNewValueData = {
						game: "gong_ball_jitu",
						win: "3,3,3",
						pcode: "m33",
						timer: "50",
						periode: 265530
					};
					break;

				case "m32":
					loadNewValueData = { "game": "samgong", "timer": "60", "periode": 56407, "angka": "4d,Jd,9c", "angka1": "2h,1h,Qh", "result": "tie", "win": "tie", "player_bs": "small", "banker_bs": "small", "player_io": "odd", "banker_io": "odd", "player_3p": 0, "banker_3p": 0, "either_3p": 0, "player_anyp": 0, "banker_anyp": 0, "either_anyp": 0 };
					break;

				case "m37":
					loadNewValueData = { "game": "bingosicbo", "pcode": "m37", "win": "4,4,5", "timer": 40 };
					break;

				case "m38":
					loadNewValueData = {
						"game": "baccaratmachine",
						"win": {
							"player": "5c-Tc-3c",
							"banker": "6c-4d-6d"
						},
						"bankerPair": 0,
						"playerPair": 0,
						"timer": 5,
						"periode": 159,
						"shoePeriode": "1-158"
					};
					break;

				case "m39":
					loadNewValueData = {
						game: 'duel_dice',
						win: '3r,4b',
						pcode: 'm39',
						timer: 60,
						periode: 428
					};
					break;

				default: break;
			}

			if (loadNewValueData) {
				this.loadNewValue(loadNewValueData);
				console.log("Summoning dummy loadNewValue for " + pcode);
			}
			break;

		case "r":
			let gameResultData = null;

			//Virtual result
			switch (pcode) {
				case "p6":
					gameResultData = { "game": "24d", "win": "18", "pcode": "p6", "timer": "300", "periode": 945294 };
					break;
				case "p9":
					gameResultData = { "game": "12d", "win": "20", "pcode": "p9", "timer": "60", "periode": 1022932 };
					break;
				case "m37":
					gameResultData = { "game": "bingosicbo", "pcode": "m37", "win": "4,4,5" };
					break;
				case "m39":
					gameResultData = { "game": "dueldice", "pcode": "m37", "win": "4,4" };
					break;
			}

			if (gameResultData)
				this.applyGameResult(gameResultData);

			break;

		case "m":
			if (isDev()) {
				console.log("Applying bet modal");

				// setBetConfirmedModal(games[pcode]);
				// setMessageModal(games[pcode], "This is dummy text");

				setWinModal(games[pcode], 100000);

				this.setState({ games: games });
			}
			break;

		case "M":
			if (!isDev()) break;

			clearModals(games[pcode]);
			this.setState({ games: games });

			break;

		case "n":
			console.log("Manual newset toggle for " + pcode);
			game.newSet = (!game.newSet) ? true : false;
			this.setState({ games: games });
			break;

		case "o":
			timer.time = 10;
			console.log("Manual Open Bet for" + pcode);
			this.setState({ timers: timers });
			break;

		case "v":
			if (!isDev()) break;

			console.log("Summoning virtual elements for " + pcode);

			// Virtual Cards
			switch (pcode) {
				case "m22":
				case "m38b":
					game.virtualCardScanResult = defaultBaccaratResult;
					break;

				case "m38":
					game.virtualCardScanResult = { "pcode": "m38", "banker": "x-x-x", "player": "5c-x-x", "bankerValue": 0, "playerValue": 5, "value": 5, "win": "", "submit": false, "periode": 158, "gameSet": 1 };
					break;

				case "m23":
					game.virtualCardScanResult = defaultDragonTigerResult;
					break;
				case "m26":
					game.lottoResult = { number: "8,5,10,6,2,1,3,4,7,x", periode: 1, submit: false, id: 60, cmd: "lottoScan", pcode: "m26" };
					break;
				case "m27":
					game.virtualCardScanResult = defaultShioFightResult;
					break;
				case "m30":
					game.lottoResult = { "number": "x,x,9,8,6", "periode": 10, "submit": false, "id": 11837, "cmd": "lottoScan", "pcode": "m30" };
					// game.lottoResult = { "number": "0,4,2,4,3", "periode": 10, "submit": false, "id": 11837, "cmd": "lottoScan", "pcode": "m30" };
					break;
				case "m37":
					game.lottoResult = { "number": "4,4,5", "periode": 10, "submit": false, "id": 14360, "cmd": "lottoScan", "pcode": "m37" };
					//["lottoScan",{"number":"2,1,2","periode":10,"submit":false,"id":27,"cmd":"lottoScan","pcode":"m31"},""]
					break;
				case "m31":
					game.lottoResult = { "number": "3,x,x", "periode": 10, "submit": false, "id": 14360, "cmd": "lottoScan", "pcode": "m31" };
					//["lottoScan",{"number":"2,1,2","periode":10,"submit":false,"id":27,"cmd":"lottoScan","pcode":"m31"},""]
					break;
				case "m32":
					game.lottoResult = {
						"number": "",
						"ballLeft": "Qh,Qd,7c",
						"ballRight": "1h,2d,4s",
						"periode": 10,
						"submit": false,
						"id": 95,
						"cmd": "lottoScan",
						"pcode": "m32"
					};
					break;
				default: break;
			}

			this.setState({ games: games });
			break;

		case "w":
			console.log("Summon win for " + pcode);

			// Win dummy data
			switch (pcode) {
				case "p7":
				case "p7b":
					game.win = "14";
					break;
				case "m19":
					game.win = "gunting,telunjuk";
					break;
				case "m26":
					game.win = "1,2,6,4,5,3,10,8,7,9";
					break;
				case "m29":
					game.win = "horse,rooster,rat";
					break;
				case "m30":
					game.win = "2,9,9,8,6";
					// game.win = "0,2,5,6,2";
					break;
				case "m31":
					game.win = "1,2,5";
					break;
				case "m37":
					game.win = "4,4,5";
					break;
				case "m32":
					game.win = "Jh,Ad,7s";
					// {
					//   "game": "samgong",
					//   "timer": "60",
					//   "periode": 28078,
					//   "angka": "Jc,3d,Kh",
					//   "angka1": "Jh,Ad,7s", //Todo: confirm that 1 have to be A like gong ball
					//   "result": "banker",
					//   "win": "banker",
					//   "player_bs": "small",
					//   "banker_bs": "big",
					//   "player_io": "odd",
					//   "banker_io": "even",
					//   "player_3p": 0,
					//   "banker_3p": 0,
					//   "either_3p": 0,
					//   "player_anyp": 0,
					//   "banker_anyp": 0,
					//   "either_anyp": 0
					// };
					break;
				case "m39":
					game.win = "3r,4b";
					break
				default: break;
			}

			this.setState({ games: games });
			break;

		case "z":
			timer.time = 0;
			console.log("Manual Close Bet for " + pcode);
			this.setState({ timers: timers }, () => {
				this.closeTimer(pcode);
			});

			break;

		default: break;
	}
}
